import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtoshivamoggacabs() {



    const cardData = {




keyword: "Belgaum to Shivamogga Cab",

headingDescription: "Belgaum Taxi Service provides safe and comfortable Belgaum to Shivamogga cab services for family trips, business travel, educational visits, medical journeys, sightseeing tours, and outstation travel. Whether you need a one-way taxi or a round-trip cab from Belgaum to Shivamogga, we offer reliable transportation with experienced drivers and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options according to your travel requirements. Our services include doorstep pickup, flexible travel schedules, transparent pricing, easy booking, and 24/7 customer support to ensure a smooth journey. Belgaum Taxi Service connects travelers between Belgaum and Shivamogga with comfortable and affordable cab solutions for personal, corporate, and tourist travel across Karnataka.",

topPlaces: [
  {
    title: "Jog Falls",
    description: "Jog Falls is one of Karnataka's most spectacular waterfalls, located near Shivamogga. It attracts tourists with its breathtaking views, natural beauty, and scenic surroundings."
  },
  {
    title: "Shivappa Nayaka Palace",
    description: "Shivappa Nayaka Palace is a historic attraction in Shivamogga known for its architecture, museum, and cultural importance, making it a popular sightseeing destination."
  },
  {
    title: "Kodachadri",
    description: "Kodachadri is a famous hill destination near Shivamogga known for trekking, mountain views, forests, and peaceful natural surroundings."
  },
  {
    title: "Sakleshpur",
    description: "Sakleshpur is a beautiful hill station known for coffee plantations, greenery, trekking trails, and scenic landscapes, making it ideal for weekend trips."
  },
  {
    title: "Agumbe",
    description: "Agumbe is known as the 'Cherrapunji of the South' for its rainforests, sunsets, waterfalls, and rich biodiversity. It is a popular destination for nature lovers."
  },
  {
    title: "Mangalore",
    description: "Mangalore is a coastal city known for beaches, temples, educational institutions, and business centers. It is a popular destination for comfortable outstation cab travel."
  },
  {
    title: "Bangalore",
    description: "Bangalore is Karnataka's major IT and business hub with corporate offices, technology parks, and commercial centers. Cab services provide convenient long-distance travel."
  },
  {
    title: "Mysore",
    description: "Mysore is a heritage city famous for Mysore Palace, Chamundi Hills, cultural attractions, and royal history, making it a preferred tourist destination."
  },
  {
    title: "Coorg",
    description: "Coorg is a scenic hill station known for coffee estates, waterfalls, forests, and pleasant weather, attracting families and tourists throughout the year."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage Site famous for ancient ruins, temples, and historical monuments, making it a popular heritage travel destination."
  }
],




"services": [
  {
    "name": "Belgaum to Shivamogga Cab",
    "description": "Book Belgaum to Shivamogga Cab for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs for family trips, business journeys, sightseeing, and personal travel with flexible one way and round trip options."
  },
  {
    "name": "Belgaum to Shimoga Cab",
    "description": "Choose Belgaum to Shimoga Cab for convenient and affordable intercity transportation. Enjoy comfortable seating, experienced drivers, clean vehicles, transparent pricing, and hassle-free booking facilities for a smooth journey."
  },
  {
    "name": "Belgaum to Shivamogga Taxi",
    "description": "Book Belgaum to Shivamogga Taxi for reliable long-distance travel with professional chauffeurs and premium vehicles. Get comfortable AC taxis for family trips, corporate travel, airport transfers, and personal journeys."
  },
  {
    "name": "Belgaum to Shimoga Taxi",
    "description": "Hire Belgaum to Shimoga Taxi for safe and comfortable transportation between cities. Enjoy affordable fares, well-maintained vehicles, experienced drivers, and flexible booking options for your travel requirements."
  },
  {
    "name": "Belgaum to Shivamogga Cab Service",
    "description": "Our Belgaum to Shivamogga Cab Service provides reliable outstation travel solutions with skilled chauffeurs and multiple vehicle options. Experience safe, timely, and comfortable journeys with premium AC cabs."
  },
  {
    "name": "Belgaum to Shimoga Taxi Service",
    "description": "Book Belgaum to Shimoga Taxi Service for convenient city-to-city travel with professional drivers and clean vehicles. Suitable for family trips, business travel, sightseeing, and personal transportation."
  },
  {
    "name": "Belgaum to Shivamogga One Way Cab",
    "description": "Hire Belgaum to Shivamogga One Way Cab for affordable single-trip travel without return charges. Enjoy doorstep pickup, fixed pricing, comfortable vehicles, and experienced chauffeurs."
  },
  {
    "name": "Belgaum to Shivamogga Cab Booking",
    "description": "Complete Belgaum to Shivamogga Cab Booking with easy online reservations, quick confirmation, and flexible vehicle choices. Select Sedan, Ertiga, Innova Crysta, or SUV cabs based on your comfort and budget."
  },
  {
    "name": "Belgaum to Shivamogga Car Rental",
    "description": "Choose Belgaum to Shivamogga Car Rental for private chauffeur-driven travel with premium vehicles. Get reliable cars for family tours, corporate trips, airport transfers, and outstation journeys."
  },
  {
    "name": "Belgaum to Shivamogga Outstation Cab",
    "description": "Book Belgaum to Shivamogga Outstation Cab for safe and comfortable long-distance travel. Our outstation taxi services include one way trips, round trips, family travel, and customized travel packages."
  },
  {
    "name": "Belgaum to Shivamogga Innova Crysta Cab",
    "description": "Reserve Belgaum to Shivamogga Innova Crysta Cab for luxury travel with spacious interiors, premium seating, and experienced drivers. Ideal for family vacations, corporate journeys, airport transfers, and group travel."
  },
  {
    "name": "Belgaum to Shivamogga Ertiga Cab",
    "description": "Book Belgaum to Shivamogga Ertiga Cab for comfortable 6 to 7 seater travel with affordable rates. Perfect for families, small groups, airport rides, and long-distance outstation journeys."
  },
  {
    "name": "Belgaum to Shivamogga Sedan Cab",
    "description": "Choose Belgaum to Shivamogga Sedan Cab for economical and comfortable travel with clean AC sedan cars and professional chauffeurs. Suitable for business trips, personal travel, and smooth intercity transportation."
  },
  {
    "name": "Belgaum to Shivamogga Round Trip Cab",
    "description": "Hire Belgaum to Shivamogga Round Trip Cab for flexible return journeys with affordable packages and experienced drivers. Ideal for sightseeing tours, family visits, business meetings, and planned travel."
  },
  {
    "name": "Belgaum to Shivamogga Private Taxi",
    "description": "Choose Belgaum to Shivamogga Private Taxi for exclusive chauffeur-driven transportation with privacy, comfort, and flexible schedules. Enjoy personalized travel solutions for families, professionals, and groups."
  },
  {
    "name": "Cheap Belgaum to Shivamogga Cab",
    "description": "Book Cheap Belgaum to Shivamogga Cab with affordable fares, reliable vehicles, and professional driver services. Enjoy budget-friendly travel without compromising safety and comfort."
  },
  {
    "name": "Best Belgaum to Shivamogga Cab Service",
    "description": "Choose the Best Belgaum to Shivamogga Cab Service offering premium vehicles, experienced chauffeurs, competitive pricing, and dependable transportation solutions for every travel requirement."
  },
  {
    "name": "Online Belgaum to Shivamogga Cab Booking",
    "description": "Complete Online Belgaum to Shivamogga Cab Booking with simple reservations, instant confirmation, transparent pricing, and multiple vehicle options for comfortable travel."
  },
  {
    "name": "Belgaum to Shivamogga Taxi Fare",
    "description": "Check Belgaum to Shivamogga Taxi Fare with affordable travel packages and flexible vehicle choices. Select Sedan, Ertiga, Innova Crysta, or SUV cabs according to your journey needs."
  },
  {
    "name": "Belgaum to Shivamogga Car Hire",
    "description": "Hire Belgaum to Shivamogga Car Hire services for private transportation with professional drivers and well-maintained vehicles. Enjoy comfortable travel for business, family, and personal trips."
  },
  {
    "name": "Belgaum to Shivamogga Cab Price",
    "description": "Get affordable Belgaum to Shivamogga Cab Price with transparent fares and multiple vehicle options. Book reliable AC cabs for safe and convenient outstation travel."
  },
  {
    "name": "Belgaum to Shivamogga Taxi Booking",
    "description": "Complete Belgaum to Shivamogga Taxi Booking with easy online reservations and quick confirmation. Travel comfortably with trusted drivers and premium cab options."
  },
  {
    "name": "Belgaum to Shivamogga Chauffeur Service",
    "description": "Book Belgaum to Shivamogga Chauffeur Service for professional driver assistance and comfortable private travel. Enjoy a premium journey experience with trained chauffeurs and quality vehicles."
  },
  {
    "name": "Belgaum to Shivamogga Travel by Cab",
    "description": "Travel from Belgaum to Shivamogga by Cab with comfortable seating, experienced drivers, and reliable transportation. Enjoy a safe and relaxing journey with flexible travel options."
  },
  {
    "name": "Belgaum to Shivamogga Family Cab",
    "description": "Choose Belgaum to Shivamogga Family Cab for spacious and comfortable travel with safe driving and reliable service. Perfect for vacations, family visits, and long-distance journeys."
  },
  {
    "name": "Belgaum to Shivamogga Corporate Cab",
    "description": "Book Belgaum to Shivamogga Corporate Cab for business travel solutions with executive vehicles and professional chauffeurs. Ideal for meetings, office travel, and corporate transportation requirements."
  },
  {
    "name": "Belgaum to Shivamogga Cab Fare",
    "description": "Get affordable Belgaum to Shivamogga Cab Fare with flexible packages and vehicle options. Choose reliable taxi services with transparent pricing and comfortable travel facilities."
  },
  {
    "name": "Belgaum to Shivamogga Taxi Near Me",
    "description": "Find Belgaum to Shivamogga Taxi Near Me for quick and reliable cab booking services. Get comfortable vehicles, professional drivers, and convenient pickup options for your journey."
  },
  {
    "name": "Belgaum Cab Services",
    "description": "Book Belgaum Cab Services for local and outstation travel with experienced chauffeurs and well-maintained vehicles. Get reliable taxi solutions for airport transfers, business trips, family travel, and long-distance routes."
  },
  {
    "name": "Best Taxi Service in Belgaum",
    "description": "Choose Best Taxi Service in Belgaum offering comfortable vehicles, professional drivers, affordable pricing, and reliable transportation solutions for local and outstation travel."
  }
],
"tableData": [
  ["Belgaum to Shivamogga Cab", "Belgaum to Shimoga Cab"],
  ["Belgaum to Shivamogga Taxi", "Belgaum to Shimoga Taxi"],
  ["Belgaum to Shivamogga Cab Service", "Belgaum to Shimoga Taxi Service"],
  ["Belgaum to Shivamogga One Way Cab", "Belgaum to Shivamogga Cab Booking"],
  ["Belgaum to Shivamogga Car Rental", "Belgaum to Shivamogga Outstation Cab"],
  ["Belgaum to Shivamogga Innova Crysta Cab", "Belgaum to Shivamogga Ertiga Cab"],
  ["Belgaum to Shivamogga Sedan Cab", "Belgaum to Shivamogga Round Trip Cab"],
  ["Belgaum to Shivamogga Private Taxi", "Cheap Belgaum to Shivamogga Cab"],
  ["Best Belgaum to Shivamogga Cab Service", "Online Belgaum to Shivamogga Cab Booking"],
  ["Belgaum to Shivamogga Taxi Fare", "Belgaum to Shivamogga Car Hire"],
  ["Belgaum to Shivamogga Cab Price", "Belgaum to Shivamogga Taxi Booking"],
  ["Belgaum to Shivamogga Chauffeur Service", "Belgaum to Shivamogga Travel by Cab"],
  ["Belgaum to Shivamogga Family Cab", "Belgaum to Shivamogga Corporate Cab"],
  ["Belgaum to Shivamogga Cab Fare", "Belgaum to Shivamogga Taxi Near Me"],
  ["Belgaum Cab Services", "Best Taxi Service in Belgaum"]
],





whychoose: [
  {
    WhyChooseheading: "Comfortable Belgaum to Shivamogga Cab Service",
    WhyChoosedescription: "Travel conveniently between Belgaum and Shivamogga with well-maintained cars, skilled chauffeurs, and flexible taxi options designed for a smooth outstation journey."
  },
  {
    WhyChooseheading: "Hassle-Free Intercity Travel",
    WhyChoosedescription: "Enjoy a relaxed ride with doorstep pickup facilities from Belgaum and direct drop services at your preferred location in Shivamogga."
  },
  {
    WhyChooseheading: "Cars Available for Every Requirement",
    WhyChoosedescription: "Select from Sedan, Ertiga, Innova, Innova Crysta, and SUV options suitable for individuals, families, and group travellers."
  },
  {
    WhyChooseheading: "Perfect Choice for Long Route Trips",
    WhyChoosedescription: "Whether travelling for work, family visits, tourism, or personal needs, our Belgaum to Shivamogga taxis provide a comfortable travel experience."
  },
  {
    WhyChooseheading: "Skilled Chauffeurs & Smooth Navigation",
    WhyChoosedescription: "Experienced drivers handle the route professionally with focus on safety, punctuality, and passenger convenience throughout the journey."
  },
  {
    WhyChooseheading: "Flexible One Way & Return Options",
    WhyChoosedescription: "Choose a one-way drop taxi or plan a return journey according to your schedule with convenient booking choices."
  },
  {
    WhyChooseheading: "Value-Focused Taxi Packages",
    WhyChoosedescription: "Get competitive pricing with suitable vehicle selections and travel plans customized according to your destination and passenger needs."
  },
  {
    WhyChooseheading: "Round-the-Clock Booking Assistance",
    WhyChoosedescription: "Our support team helps you with vehicle selection, fare details, and reservations for your Belgaum to Shivamogga travel anytime."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Shivamogga Cab Service?",
    answer: "Yes, we provide comfortable Belgaum to Shivamogga taxi services with multiple vehicle options and professional drivers."
  },
  {
    question: "Can I book a one-way taxi from Belgaum to Shivamogga?",
    answer: "Yes, one-way cab services are available for travellers who need a direct drop without a return journey."
  },
  {
    question: "What vehicles can I choose for this route?",
    answer: "Customers can select Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs based on their comfort and group size."
  },
  {
    question: "Is pickup available from my location in Belgaum?",
    answer: "Yes, pickup can be arranged from homes, hotels, offices, railway stations, airport areas, and other locations in Belgaum."
  },
  {
    question: "Can I hire a taxi from Belgaum to Shivamogga for family travel?",
    answer: "Yes, spacious and comfortable vehicles are available for family trips with enough seating and luggage space."
  },
  {
    question: "Are round-trip cabs available between Belgaum and Shivamogga?",
    answer: "Yes, return journey packages are available with flexible travel schedules according to customer requirements."
  },
  {
    question: "Is this taxi service suitable for business travel?",
    answer: "Yes, the service is suitable for business meetings, official visits, corporate travel, and professional transportation needs."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable toll, parking, and additional travel charges depend on the selected package and are communicated during booking."
  },
  {
    question: "Can I book a Belgaum to Shivamogga cab at any time?",
    answer: "Yes, taxi booking assistance is available 24/7 for planned trips and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Shivamogga Cab?",
    answer: "Provide your pickup location, travel date, passenger details, and preferred vehicle type to get fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Desai",
    feedback: "The journey from Belgaum to Shivamogga was comfortable and well-managed. The driver was experienced, and the car condition was excellent.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meera Kulkarni",
    feedback: "A smooth taxi experience with timely pickup and a comfortable vehicle. The service made our family travel easy and stress-free.",
    rating: 5
  }
];









    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Shivamogga Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-shivamogga-cab.webp",
  "description":
    "Book Belgaum to Shivamogga Cab with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Shivamogga (Shimoga) with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for family trips, business travel, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-shivamogga-cab"
  }
};






    return (
        <div>

<Helmet>
  <title>Belgaum to Shivamogga Cab | One Way Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Shivamogga Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Shivamogga with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="belgaum to shivamogga cab fare, belgaum to shivamogga cab service, belgaum cab services, best taxi service in belgaum, belgaum to shivamogga cab package, Belgaum to Shivamogga Cab, Belgaum to Shimoga Cab, Belgaum to Shivamogga Taxi, Belgaum to Shimoga Taxi Service, Belgaum to Shivamogga One Way Cab, Belgaum to Shivamogga Outstation Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/28.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtoshivamoggacabs;